import {
  Button,
  Tooltip,
  Icon,
  type ButtonProps,
  type IconProps,
  type TooltipProps
} from "../../components";

export interface IconButtonProps extends IconProps {
  tooltipText?: string;
  buttonProps?: Omit<ButtonProps, "children">;
  tooltipProps?: Omit<TooltipProps, "content">;
}

const IconButton = ({
  icon,
  size = 24,
  fillColor = "text",
  tooltipText,
  buttonProps,
  tooltipProps
}: IconButtonProps) => {
  const isTooltipDisabled =
    tooltipProps?.disabled ?? tooltipText === undefined;

  return (
    <Tooltip
      data-bark-component="IconButton"
      {...tooltipProps}
      content={tooltipText}
      disabled={isTooltipDisabled}
      data-testid="icon-button-tooltip"
    >
      <Button
        variant="icon"
        {...buttonProps}
        w={`${size * 1.6}px`}
        h={`${size * 1.6}px`}
        data-testid="icon-button"
      >
        <Icon icon={icon} size={size} fillColor={fillColor} />
      </Button>
    </Tooltip>
  );
};

export default IconButton;
